import {Timestamped} from 'common/src/modules/movie/movieRendering';
import {IShape} from 'common/src/modules/movie/movieShapes.types';

function getShapeTransformMatrix(shape: Timestamped<IShape>): DOMMatrix {
  const {
    tr: {
      an: [anchorX, anchorY],
      p: [translateX, translateY] = [0, 0],
      s: [scaleW, scaleH] = [0, 0],
      r: rotation = 0,
    },
  } = shape;

  return new DOMMatrix()
    .translateSelf(translateX, translateY)
    .rotateSelf(0, 0, (rotation / Math.PI) * 180)
    .skewXSelf(0)
    .skewYSelf(0)
    .scaleSelf(scaleW, scaleH)
    .translateSelf(-anchorX, -anchorY);
}

export default getShapeTransformMatrix; 